/**
 * Эот файл сгенерирован автоматически при помощи плагина PlmVersionPlugin.
 * Он содержит версию приложения из package.json.
 * Не пытайтесь вносить сюда какие-то изменения вручную.
 */

export const version = "19.0.0";
